// extracted by mini-css-extract-plugin
export default {"configModal":"lead_configModal__QLKlp","leadViewModal":"lead_leadViewModal__OlE+n"};